<div class="container-fluid">
    <div class="row g-1">
        <div class="col-6">
            <div class="card shadow-sm bg-secondary-subtle">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Upload standard documents</h3>
                </div>
                <div class="card-body p-2">
                    <customers-upload-documents 
                        [documents]="documents?.standard" 
                        typeSection="STANDARD" 
                        [readonlyCustomersDocumentsForNewClients]="readonlyCustomersDocumentsForNewClients"
                        (documentsChanged)="handleDocumentsChanged($event)"/>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card shadow-sm bg-info-subtle">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Upload extra documents</h3>
                </div>
                <div class="card-body p-2">
                    <customers-upload-documents 
                        [documents]="documents?.extra" 
                        typeSection="EXTRA" 
                        [readonlyCustomersDocumentsForNewClients]="readonlyCustomersDocumentsForNewClients"
                        (documentsChanged)="handleDocumentsChanged($event)"/>
                </div>
            </div>
        </div>
    </div>
</div>